import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Fade } from "react-awesome-reveal";

import p3 from '../Images/p3.jpg'
import p4 from '../Images/p4.jpg'
import p5 from '../Images/p5.jpg'
import p6 from '../Images/p6.jpg'
import p7 from '../Images/p7.jpg'
// --- Styled Components ---

const SectionContainer = styled.section`
  padding: 10px 0;
  width: 100%;
  overflow: hidden; // Hides the images that are outside the view
  background: #fff;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Title = styled.h2`
  padding-left: 20px;
  font-size: 1.5rem;
  font-weight: bold;
  color: #439E6D;
  text-transform: uppercase;
  // margin-bottom: 30px;
  max-width: 1200px;
  margin-inline: auto;
`;

// The animation keyframe for infinite scrolling
const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); } 
`;

const CarouselTrack = styled.div`
  display: flex;
  width: calc(250px * 10); // Adjust based on image width * total images
  animation: ${scroll} 25s linear infinite; // Speed of movement

  // &:hover {
  //   animation-play-state: paused; // Stop moving when user hovers
  // }
`;

const Slide = styled.div`
  width: 300px; // Based on your image ratio
  height: 200px;
  padding: 0 15px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }
`;

// --- Mock Data ---
// We duplicate the items to ensure the loop is infinite and seamless
const partnerImages = [
p3,p4,p5,p6,p7
];

const fullList = [...partnerImages, ...partnerImages, ...partnerImages, ...partnerImages];

// --- Component ---

const ClientsCarousel = () => {
  return (
    <SectionContainer>
      <Fade triggerOnce>
        <Title>Our Clients</Title>
      </Fade>

      <CarouselTrack>
        {fullList.map((img, index) => (
          <Slide key={index}>
            <img src={img} alt={`Partner ${index}`} />
          </Slide>
        ))}
      </CarouselTrack>
    </SectionContainer>
  );
};

export default ClientsCarousel;